/**
 * Brand profile loaded at app boot.
 *
 * Resolution order (first match wins):
 *   1. `/api/v1/branding/resolve?host=<hostname>` — runtime lookup (custom domain support)
 *   2. `window.__PLATFORM_BRAND__` — server-injected during SSR (future)
 *   3. Hardcoded `DEFAULT_BRAND` below — the only place that's allowed
 *
 * Once the brand resolves, it's piped into Tailwind CSS variables for theming
 * and into all user-visible copy via the `useBrand()` hook. The product name,
 * support email, legal name — anything brand-shaped — never appears as a string
 * literal in component code.
 */
export interface Brand {
  displayName: string;
  logoUrl: string | null;
  primaryColor: string;
  accentColor: string;
  supportEmail: string;
  legalName: string;
}

export const DEFAULT_BRAND: Brand = Object.freeze({
  displayName: 'Magzit',
  // Icon mark (transparent bg) cropped from src/assets/brand/magzit-logo-original.png.
  logoUrl: '/magzit-mark.png',
  primaryColor: '#0F172A',
  // indigo-600 — passes WCAG AA (≥4.5) for text on white and white text on it,
  // both directions (indigo-500 #6366F1 lands at 4.46, just under).
  accentColor: '#4F46E5',
  // magzit.ai mailbox pending domain registration — see KNOWN-ISSUES.
  supportEmail: 'support@magzit.ai',
  legalName: 'Magzit LLC',
});
